import { useState } from 'react';
import { Pressable, Platform, StyleSheet } from 'react-native';

import Colors from '../../constants/Colors';
import useColorScheme from '../../hooks/useColorScheme';
import { ArrowUpIcon, ArrowDownIcon } from '../../native/icons';
import { formatPrice } from '../../utils/locations';
import { Icon } from '../Icon';
import { TransparentRow } from '../Row';
import { TextBody, TextTag } from '../StyledText';
import { TransparentView, View } from '../Themed';

export default function CartItemSection({
  title,
  total,
  children,
  expanded = false,
}: {
  title: string;
  total: number;
  children: React.ReactNode;
  expanded?: boolean;
}) {
  const theme = useColorScheme();
  const [isOpen, setIsOpen] = useState(false);

  const iconRendered =
    Platform.OS === 'web' ? (
      <Icon
        name={isOpen ? 'arrowUp' : 'arrowDown'}
        style={styles.cartItemArrow}
      />
    ) : isOpen ? (
      <ArrowUpIcon />
    ) : (
      <ArrowDownIcon />
    );

  return (
    <View
      style={{
        borderBottomWidth: 1,
        borderBottomColor: Colors[theme].lines,
        marginBottom: 16,
      }}
    >
      <Pressable
        style={[
          styles.row,
          {
            flex: 1,
            flexDirection: 'row',
            justifyContent: 'space-between',
            position: 'relative',
          },
        ]}
        onPress={() => setIsOpen(!isOpen)}
      >
        <TransparentRow
          style={[
            expanded && { flexDirection: 'column', alignItems: 'flex-start' },
            { flex: 1, justifyContent: 'space-between' },
          ]}
        >
          <TextBody bold>Total for {title}</TextBody>
          {expanded ? (
            <TransparentRow
              style={{
                alignItems: 'center',
                flex: 1,
                width: '100%',
                justifyContent: 'space-between',
              }}
            >
              <TextTag>Show {isOpen ? 'less' : 'more'}</TextTag>
              {iconRendered}
              {expanded ? (
                <TextBody bold>{formatPrice(Number(total))}</TextBody>
              ) : null}
            </TransparentRow>
          ) : null}

          {expanded ? null : iconRendered}
          {expanded ? null : (
            <TextBody bold>{formatPrice(Number(total))}</TextBody>
          )}
        </TransparentRow>
      </Pressable>

      {isOpen ? (
        <TransparentView style={{ paddingBottom: 10 }}>
          {children}
        </TransparentView>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  cartItemArrow: {
    width: 24,
    height: 24,
    position: 'absolute',
    left: '50%',
    top: 0,
  },
});
